import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";


@Injectable({ providedIn: 'root' })
export class ExportPlanCSVUsecase implements UseCase< BaseRequest<string>,HttpResponse<Blob>> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(param:  BaseRequest<string>): Observable<HttpResponse<Blob>> {
    return this.planRepository.exportPlanCSV(param);
  }

}
